import React, { useState, useEffect } from 'react';
import {
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader
} from '@coreui/react';
import { useTranslation } from 'react-i18next';
import CIcon from '@coreui/icons-react';
import { cilPeople, cilCarAlt, cilListRich, cilCalendar } from '@coreui/icons';
import { adminAPI } from '../../services/api';

const AdminDashboard = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalCarpools: 0,
    totalRides: 0,
    activeRides: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await adminAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-dashboard">
      <h1 className="admin-page-title">{t('admin.dashboard') || 'Admin Dashboard'}</h1>
      
      <CRow className="mb-4">
        <CCol xs={12} sm={6} lg={3}>
          <CCard className="mb-4">
            <CCardBody>
              <div className="d-flex align-items-center">
                <div className="stats-icon bg-primary text-white rounded p-3 me-3">
                  <CIcon icon={cilPeople} size="xl" />
                </div>
                <div>
                  <div className="fs-4 fw-bold">{stats.totalUsers}</div>
                  <div className="text-medium-emphasis small">{t('admin.totalUsers') || 'Total Users'}</div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12} sm={6} lg={3}>
          <CCard className="mb-4">
            <CCardBody>
              <div className="d-flex align-items-center">
                <div className="stats-icon bg-info text-white rounded p-3 me-3">
                  <CIcon icon={cilCarAlt} size="xl" />
                </div>
                <div>
                  <div className="fs-4 fw-bold">{stats.totalCarpools}</div>
                  <div className="text-medium-emphasis small">{t('admin.totalCarpools') || 'Total Carpools'}</div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12} sm={6} lg={3}>
          <CCard className="mb-4">
            <CCardBody>
              <div className="d-flex align-items-center">
                <div className="stats-icon bg-warning text-white rounded p-3 me-3">
                  <CIcon icon={cilListRich} size="xl" />
                </div>
                <div>
                  <div className="fs-4 fw-bold">{stats.totalRides}</div>
                  <div className="text-medium-emphasis small">{t('admin.totalRides') || 'Total Rides'}</div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12} sm={6} lg={3}>
          <CCard className="mb-4">
            <CCardBody>
              <div className="d-flex align-items-center">
                <div className="stats-icon bg-success text-white rounded p-3 me-3">
                  <CIcon icon={cilCalendar} size="xl" />
                </div>
                <div>
                  <div className="fs-4 fw-bold">{stats.activeRides}</div>
                  <div className="text-medium-emphasis small">{t('admin.activeRides') || 'Active Rides'}</div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow>
        <CCol xs={12} lg={6}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>{t('admin.recentActivity') || 'Recent Activity'}</strong>
            </CCardHeader>
            <CCardBody>
              <p className="text-muted">{t('admin.activityPlaceholder') || 'Activity chart will be displayed here'}</p>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12} lg={6}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>{t('admin.statistics') || 'Statistics'}</strong>
            </CCardHeader>
            <CCardBody>
              <p className="text-muted">{t('admin.statisticsPlaceholder') || 'Statistics chart will be displayed here'}</p>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
};

export default AdminDashboard;

